import { render, staticRenderFns } from "./ContentStoreProductProvider.vue?vue&type=template&id=787d61fe"
import script from "./ContentStoreProductProvider.vue?vue&type=script&lang=js"
export * from "./ContentStoreProductProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports